<template>
  <div>
    <div id="dev-tool-root">
      Switch User
      Switch Modes
      Switch Layouts
      <router-link to="/dev">Dev</router-link>
      <router-link to="/">Prod</router-link>
      Component (Selector)
    </div>
    <div id="app">
      <slot name="app" /> 
    </div>
    <Debugger />
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import {parse, stringify} from 'flatted';

export default {
  components: {
    Debugger: () => import("@/developing/dev-components/Debugger")
  },
  computed: {
    currentUser() {
      return parse(stringify(this.$context.$currentUser));
    }
  }
}
</script>

<style>
#dev-tool-root {
  z-index: 9999999999999;
  position: fixed;
  background: #00000063;
  width: auto;
  height: 20px;
  top: 0;
  left: 0;
  right: 0;
  color: white;
}
</style>